export const locale = {
  HEADING_NAME: "陳 渭東",
  HEADING_TITLE: ", DPsych",
  SUBHEADING: "心理治療・榮格沙遊・Social Dreaming - 香港, 英國及其他",
  TAB1: "關於",
  TAB2: "治療",
  TAB3: "約見",
  TAB4: "Memories",
  TAB5: "social dreaming",
  META_ABOUT_TITLE: "陳渭東 Perry WT Chan — 心理治療師 / 輔導員，愛丁堡、英國（包括倫敦）及香港",
  META_ABOUT_DESC: "華人心理治療師，提供心理治療、榮格沙遊及 Social Dreaming，廣東話、英語及普通話服務。處理抑鬱、焦慮、創傷及關係困難。愛丁堡面談，全英國及香港網上心理輔導。首次諮詢免費。",
  META_THERAPY_TITLE: "治療 — 精神動力、榮格沙遊及人本治療 — 陳渭東",
  META_THERAPY_DESC: "精神動力心理治療、榮格沙遊治療及人本心理輔導，處理抑鬱、焦慮、童年創傷及關係困難。愛丁堡面談及全英國、香港網上輔導。",
  META_SESSION_TITLE: "約見資料及收費 — 陳渭東，心理治療師",
  META_SESSION_DESC: "心理輔導約見資料、收費及預約方法。愛丁堡面談，全英國包括倫敦、香港及海外提供網上輔導服務。",
  META_MEMORIES_TITLE: "Memories — 陳渭東，心理治療師",
  META_MEMORIES_DESC: "陳渭東的個人反思及創意探索，駐愛丁堡華人心理治療師，提供倫敦及全英國網上輔導。",
  META_SD_TITLE: "Social Dreaming Matrix — 陳渭東，英國及香港",
  META_SD_DESC: "陳渭東主持的 Social Dreaming Matrix 活動，英國（包括倫敦）及香港，一起探索集體夢境與潛意識。",
  H1_ABOUT: "廣東話,普通話及英語心理治療師 — 愛丁堡、英國（包括倫敦）及香港網上心理輔導",
  H1_THERAPY: "治療方法 — 人本、精神動力及榮格治療，以及沙遊治療",
  H1_SESSION: "約見資料及收費",
  H1_MEMORIES: "反思與創意探索",
  INTRO_SUB1: "心理治療",
  INTRO_SUB2: "榮格沙遊",
  INTRO_SUB3: "Social Dreaming",
  INTRO_SCROLL: "往下滑動",
  INTRO_LINE1: "''靈魂與靈魂，夢與夢''",
  INTRO_LINE2: "書法由康所贈，平成二十九年三月（2017）",
  H1_SD: "Social Dreaming Matrix — 英國（愛丁堡及倫敦）及香港活動",
  H2_WELCOME_SEO: " — 廣東話、普通話及英語網上心理治療",
  H2_CORE_SEO: " — 人本及精神動力輔導理念",
  H2_EXP_SEO: " — 抑鬱、焦慮、創傷、童年及關係困難",
  H2_QUALI_SEO: " — BACP註冊心理治療師，心理治療博士，蘇黎世榮格學院",
  H2_JOURNEY_SEO: " — 榮格深度心理學與治療過程",
  H2_APPROACH_SEO: " — 精神動力、榮格及人本心理治療",
  H2_HOWWORKS_SEO: " — 透過夢境、象徵及沙遊探索潛意識",
  H2_NOTKNOWING_SEO: " — 在治療旅程中擁抱未知",
  H2_POEM_SEO: " — 透過治療實現心靈轉化與成長",
  H2_SANDPLAY_SEO: " — 治療中的象徵與原型表達",
  H2_FEES_SEO: " — 英國及香港輔導收費",
  H2_SESSIONS_SEO: " — 首次輔導會面須知",
  H2_WHERE_SEO: " — 愛丁堡面談，英國(包括倫敦)及香港網上輔導",
  H2_LOST_SEO: " — 治療旅程的個人反思",
  H2_ENCOUNTER_SEO: " — 透過創意探索認識自我",
  H2_KOANS_SEO: " — 靜觀修行與心理治療",
  H2_WAYS_SEO: " — 存在、成為與個體化",
  H2_WHATISSDM_SEO: " — 集體夢境探索",
  ALT_INTRO_1: "書法作品，華人心理治療師，提供廣東話及普通話網上心理輔導，服務倫敦、英國及香港客戶",
  ALT_INTRO_2: "書法藝術作品，華人心理治療師，倫敦、英國及香港心理治療及輔導服務",
  ALT_INTRO_3: "書法藝術作品，華人心理治療師，倫敦、英國及香港心理治療及輔導服務",
  ALT_ABOUT_PHOTO: "陳渭東，華人心理治療師及輔導員，提供廣東話、英語及普通話網上心理輔導，服務倫敦、全英國及香港客戶",
  ALT_ABOUT_BACP: "BACP註冊華人輔導員及心理治療師，提供廣東話及普通話服務，服務倫敦、全英國及香港客戶",
  ALT_ABOUT_CONDITIONS: "心理治療處理抑鬱、焦慮、創傷、壓力、關係困難、LGBT+議題、喪親、孤獨感，提供廣東話及普通話網上輔導，服務倫敦、英國及香港客戶",
  ALT_ABOUT_DARK: "抑鬱、焦慮、憤怒、壓力、關係困難，廣東話及普通話網上心理治療，服務倫敦、英國及香港",
  ALT_THERAPY_MIST: "兩人在迷霧中前行，探索心理治療中的未知，提供倫敦、英國及香港網上輔導服務",
  ALT_THERAPY_COLLEGE: "愛丁堡舊學院，陳渭東華人心理治療師，服務倫敦、全英國及香港客戶",
  ALT_THERAPY_CITY1: "霧中城市，探索心理治療中的未知，廣東話及普通話心理治療師服務倫敦、英國及香港",
  ALT_THERAPY_PROCESS: "精神動力心理治療的治療過程，提供廣東話、普通話及英語網上服務予倫敦、英國及香港客戶",
  ALT_THERAPY_CITY2: "霧中城市反映榮格沙遊治療的心路歷程，倫敦、英國及香港華人心理治療",
  ALT_SESSION_FOREST: "心理治療及輔導服務，愛丁堡面談，倫敦、全英國及香港網上服務，廣東話、普通話及英語",
  ALT_SESSION_MAP: "愛丁堡面談輔導，倫敦、英國及香港網上心理治療服務",
  ALT_MEMORIES_EXPLORE: "魚探索深處，華人心理治療師，提供廣東話及普通話網上治療，服務倫敦、英國及香港",
  ALT_MEMORIES_PERRY: "魚，駐愛丁堡華人心理治療師及藝術家，倫敦、英國及香港廣東話及普通話網上輔導",
  ALT_MEMORIES_DISCOVER: "魚，反映心理治療旅程，廣東話及普通話心理治療服務倫敦、英國及香港客戶",
  ALT_SD_MUSHROOM: "夢境蘑菇，倫敦、英國及香港 Social Dreaming 集體夢境活動",
  ALT_SD_FISH: "夢境魚，倫敦、英國及香港社群 Social Dreaming 集體夢境活動",
  WELCOMETITLE: "歡迎",
  WELCOME: "如果你正面對情緒困擾、壓力、關係問題、人生困惑，或只是想深入了解自己，心理輔導可以提供一個安全的空間，讓你慢慢探索自己的內心世界。你好，你可以叫我Perry。我現居於蘇格蘭愛丁堡。我於愛丁堡提供面談服務，亦為全英國（包括倫敦等城市）及香港的來訪提供網上心理輔導與心理治療服務，和榮格沙遊治療，語言包括廣東話、普通話及英語。我也是一個Social Dreaming（SD）的host，我定期在倫敦舉辦 SD matrix。",
  CORETITLE: "我的理念",
  CORE1: "我並不能「治癒」。真正的療癒，是在我們彼此一起“存在“（being）的過程中自然發生的。因此，在這段旅程中，我會成為你的同行者。與其將症狀病理化，我更傾向把它們視為每個人心靈的表達。每一個人都有獨特的故事、經歷、性格、行為模式、情結、心理結構與靈魂。這些症狀往往蘊含著象徵意義，指引我們走向個體化（individuation）的道路。",
  CORE2: "有些事情在當下也許難以理解，但我相信無意識總是走在我們前面。我致力於創造一個安全而穩定的心理空間，讓我們能夠一起進入心靈的深處——「讓雨下吧，讓風吹吧，讓水流吧，讓火燒吧。讓每件東西得到發展，讓將形成的有它形成的時間。」——《紅書》，卡爾·榮格",
  JOURNEYTITLE: "旅程",
  JOURNEY1: "作為一個心理治療師，多年來我一直在學習（仍在學習中），不是如何對人進行心理分析，而是如何在關係之中用「心」傾聽，如何用雙眼看見，甚至如何單純地做一個人，與世界靈魂（Anima Mundi）聯結。",
  JOURNEY2: "我一直在路上（並會一直如此） — 無論是現實中，還是內心的旅程。這條路會把我帶到哪裡？它既不是某個需要到達的地方，也不是終點。它更像是一個持續不斷的過程：去生成、去感受、去思考、去想像、去做夢、去寫作、去創作、去與世界相遇、去與自己的身體連結、去……有些經驗很難用語言表達。這條路將帶我們到達一個言語無法盡述的地方。這是一條通往智慧、通往賢者之石、通往神話、通往古老、通往完整的道路。如果你願意與我同行，我們可以一起慢慢探索、沉澱與轉化，就像在煉金術的坩堝中（或煉丹術的鼎爐中），淬煉、修煉出我們自身的本質。",
  JOURNEYPIC: "Journeying into the (collective) unconscious, 2024 spring",
  NAME: "專業資格",
  QUALI1: "•	心理治療與輔導博士 (DPsych; 愛丁堡大學 The University of Edinburgh)",
  QUALI3: "•	Certificate in Host of Social Dreaming (Social Dreaming International Network)",
  QUALI4: "•	英國心理輔導與心理治療協會註冊會員 (BACP; 註冊編號 388438)",
  QUALI5: "•	蘇黎世榮格學院 C. G. Jung Institute, Zürich (Training candidate)",
  QUALI6: "•	國際沙遊治療學會訓練 - 英國及愛爾蘭分會 (ISST/BISS) (Training candidate)",
  PIC2: "Edinburgh, 2020 winter",
  EXPTITLE: "臨床經驗",
  EXP: "許多來尋求心理治療的人，往往在童年或家庭關係中曾經歷困難的成長經驗。這些早期經歷，有時會在成年後以情緒困擾、人際關係困難或內在衝突的形式呈現。在治療的過程中，我們會一起逐步理解，並慢慢轉化這些內在經驗、情緒與關係。我主要專注於早期關係創傷（early relational trauma），例如童年時期的虐待、忽視，以及成長過程中的心理創傷。此外，我亦有與不同背景的來訪者工作的經驗，處理各種心理健康及情緒議題，包括：",
  EXP1: "•	抑鬱",
  EXP2: "•	焦慮",
  EXP3: "•	憤怒情緒",
  EXP4: "•	生活壓力",
  EXP5: "•	關係困難",
  EXP6: "•	LGBT+ 相關議題",
  EXP7: "•	睡眠問題",
  EXP8: "•	喪親與哀傷",
  EXP9: "•	孤獨感",
  EXP10: "•	自尊與自我價值",
  EXP11: "•	跨文化與身份認同議題",
  EXP12: "•	人生中感到迷失或停滯不前",
  EXP_01: "我亦會與一些未必正在面對特定的困難的來訪者工作，但希望透過心理輔導或心理治療，更深入地了解自己，培養更深的自我覺察，並更全面地認識自己的內心世界。",
  GET1: "Get in Touch",
  E1: "perrywtchan@protonmail.com",
  COPY1: "© 2021-2026, Perry W.T. Chan. All Rights Reserved.",
  APPTITLE1: "方法",
  APP1: "我並沒有一個治療方法，但同時，我有。",
  APP2_1: "我的專業訓練以心理動力學（psychodynamic）與人本取向（person-centred）為基礎，而我的實踐（以及我作為一個人的存在）亦深受",
  APP2_2: "榮格（Jung）",
  APP2_3: "和",
  APP2_4: "德勒茲與瓜達里（Deleuze & Guattari）",
  APP2_5: "的思想的影響。我以這些理論作為根基，但同時亦嘗試超越它們——彷彿沒有任何既定的方法——讓我們能夠在過程中自由而創造性地流動。是的，這本身就是一個悖論。",
  APP2_6: "我的「（無）方法」受到不同心理治療理論與哲學的啟發。然而，在我們的關係裡，我會暫時放下這些理論，回到最重要、最根本的事情：我們之間的靈魂相遇。",
  JUNGINTRO: "卡爾・榮格（C. G. Jung，1875–1961），瑞士精神科醫生及精神分析學家。榮格取向的心理治療透過探索各種心理素材，強調整合意識與無意識，以促進個人的成長與轉化——這是一個逐漸成為更平衡、更真實、更完整的自己的過程。",
  DELEUZEINTRO: "德勒茲（Gilles Deleuze，1925–1995），法國哲學家；瓜達里（Félix Guattari，1930–1992），法國精神分析學家。就像蘑菇及其菌絲網絡（mycelium）一樣，他們的哲學思想挑戰並超越既有的結構與固定的身份認同，走向各種可能性——「生成（becoming）某種全新而意想不到的事物」。這種創造性的關係發生在行動之中、非線性的過程之中、在「生成」之中，從而促進轉化與變化。",
  PIC_SHELL: "熊野古道，日本 2026 冬",
  PIC3: "舊學院，愛丁堡 2020 冬",
  PIC4: "土偶, 日本, 昭和51年三月製作",
  APPTITLE2: "How it works",
  APP3: "我認為，心理治療並不是為了「修復」某些問題。它更像是兩個人坐在一起對話，不僅嘗試理解情緒困擾、失調的想法或行為，更重要的是——讓無意識帶領我們，並在我們身上發揮作用。我們學習放下控制，傾聽內在的智慧老人、內在的靈，和內在的神性。",
  APP4: "無意識往往透過象徵與原型與我們溝通。在治療關係中，我們會透過圖像、故事、夢境以及沙盤，探索無意識。我們會一起乘上無意識的浪潮。",
  APPTITLE3: "The Not-knowing",
  APP5_1: "當我在人生的旅程中走過一半的時候，",
  APP5_2: "某天，不經意地踏進一片幽暗的森林，",
  APP5_3: "在其中迷失了前進的方向。",
  APP5_4: "那片森林荒涼、崎嶇而無邊無際，身處其中所感受的煎熬讓人痛不欲生，只要一想起就覺得不寒而栗，毛骨悚然。",
  APP5_5: "我要敘說在那裡經歷的一切，",
  APP5_6: "雖然我都不明白自己如何置身彼處的。",
  APP6: "——《神曲・地獄篇》第一曲，但丁・阿利吉耶里",
  APP7: "想像我們兩人嘗試用指南針，在一片黑暗而迷霧瀰漫的森林中繪製地圖。那也許是一個黑暗的深淵，一個深不可測的領域，遠遠超出我們理解的能力。我們迷失、找到方向，又再次迷失；前進，也再次退回。我們一同在這煉獄般淨化靈魂的螺旋中移動——愈走愈深。",
  PIC5: "迷霧中的愛丁堡，2020 春",
  PIC6: "我的朝聖之路到世界盡頭Finisterre，2025 冬",
  PIC6_BIRD: "鳥，東京 2018 春",
  APPTITLE4: "一首詩，一個過程與煉金",
  APP9: "Two tiny eggs in the alchemical bird's nest",
  APP10: "Dream the undreamable",
  APP11: "Speak the unspeakable",
  APP12: "Feel the “unfeelable”",
  APP13: "Formulate the unformulated",
  APP14: "Experience the incomprehensible",
  APP15: "The glimmering golden egg encapsulates our whole world",
  APP16: "We entangle, we disentangle — and begin again",
  APP17: "當事情開始變得可以理解，並逐漸展現其意義時，心靈的轉化便可能在這個過程中發生。就像煉金術一樣，原始的材料會在過程中慢慢轉化為黃金。在這個過程中，可能逐漸浮現的是：更深的自我覺察、更完整的自我感、一種更深的能力去擁抱生命中的未知，以及在不再重複不健康模式的情況下，作出選擇與決定的能力。",
  APPTITLE5: "榮格沙遊",
  APP18: "我亦將沙遊治療融入治療過程之中。沙盤提供了一個Dora Kalff所描述的「自由而受保護的空間」，讓心靈能夠以象徵性與原型性的方式表達。",
  APP19: "在我們這個被保護的關係中，圖像逐漸浮現，故事慢慢成形，一些原本看不見的事物也開始變得可見。在與創傷相關的治療中，沙遊治療尤其能提供支持，因為有時單靠語言的表達，可能並不足以承載那些經驗。",
  COPY2: "© 2021, Perry W.T. Chan. All Rights Reserved.",
  E2: "Get in Touch: perrywtchan@protonmail.com",
  PIC7: "A misty forest, Yellowcraig 2021 summer",
  PRACTITLE1: "Fees",
  PRAC1: "I provide service mainly for clients based in the UK (in-person/online) and in Hong Kong (online only) at the rate as follows:",
  FEE_COL1: '首次諮詢（50分鐘）',
  FEE_COL2: '其後每節（50分鐘）',
  FEE_UK: '居於英國的來訪（£）',
  FEE_HK: '居於香港的來訪（HK$）',
  FEE_FREE: '免費',
  FEE_CONCESSION: '如有經濟需要，歡迎查詢優惠收費。',
  PRACTITLE2: "First & Following Sessions",
  PRAC2: "I offer our first session gratis, in which we will get to know each other, talk about policies and how we can work together, and most importantly, see whether it feels right for you to work with me.",
  PRAC3: "When we agree to work together and on a mutually suitable time to meet, I undertake our work by providing regular weekly sessions.",
  PIC8: "A floating lighthouse, Yellowcraig 2021 summer",
  PIC9: "Two people navigating in the mist, Yellowcraig, 2021 Summer",
  PRACTITLE3: "Where?",
  PRAC4: "I offer face-to-face, online (Microsoft Teams) counselling session.",
  PRAC5: "For face-to-face session, I practice at:",
  PRAC6: "South Side Centre",
  PRAC7: "86 Causewayside",
  PRAC8: "Edinburgh",
  PRAC9: "EH9 1PY",
  COPY3: "© 2021, Perry W.T. Chan. All Rights Reserved.",
  E3: "Get in Touch: perrywtchan@protonmail.com",

  // Session Info Gateway
  SESSION_GATEWAY_TITLE: "你居住在哪裡？",
  SESSION_CARD_UK_TITLE: "英國",
  SESSION_CARD_UK_DESC: "",
  SESSION_CARD_EDINBURGH_TITLE: "愛丁堡",
  SESSION_CARD_EDINBURGH_DESC: "面談",
  SESSION_CARD_UK_OTHER_TITLE: "其他城市",
  SESSION_CARD_UK_OTHER_DESC: "網上",
  SESSION_CARD_HK_TITLE: "香港",
  SESSION_CARD_HK_DESC: "網上",
  SESSION_CARD_INTL_TITLE: "英國/香港以外",
  SESSION_CARD_INTL_DESC: "網上",
  SESSION_BACK: "← 約見資料",
  SESSION_HEADING_EDINBURGH: "居住在愛丁堡的來訪",
  SESSION_HEADING_UK: "居住在愛丁堡以外英國其他城市的來訪",
  SESSION_HEADING_HK: "居住在香港的來訪",
  SESSION_HEADING_INTL: "居住在英國或香港以外的來訪",

  // Session Info — Edinburgh
  META_SESSION_EDINBURGH_TITLE: "愛丁堡面談輔導及沙盤治療 — 陳渭東",
  META_SESSION_EDINBURGH_DESC: "愛丁堡面談心理治療、輔導及榮格沙盤治療，BACP註冊華人心理治療師陳渭東。首次諮詢免費。",
  H1_SESSION_EDINBURGH: "愛丁堡面談輔導 — 華人心理治療師",
  SESSION_EDINBURGH_INTRO: "",
  SESSION_EDINBURGH_FEES_TITLE: "愛丁堡面談或網上心理治療收費",
  SESSION_EDINBURGH_FEES_INTRO: "",
  SESSION_EDINBURGH_FEE_FIRST: "首次諮詢（50分鐘）：免費",
  SESSION_EDINBURGH_FEE_FOLLOWING: "其後每節（50分鐘）：£75",
  SESSION_EDINBURGH_FEE_CONCESSION: "如有經濟需要，歡迎查詢優惠收費。",
  SESSION_EDINBURGH_FIRST_TITLE: "首次及其後諮詢",
  SESSION_EDINBURGH_FIRST_P1: "首次會面是免費的，我們會互相認識，談談政策及如何一起工作，最重要的是，看看你是否覺得與我合作是適合的。當我們同意一起工作並約定合適的時間後，我會提供每週定期的治療時段。",
  SESSION_EDINBURGH_SANDPLAY_TITLE: "沙盤治療",
  SESSION_EDINBURGH_SANDPLAY_P1: "在愛丁堡的面談治療中，沙盤治療可以作為我們工作的一部分。沙盤提供了一個自由而受保護的空間，讓難以用言語表達的思緒和感受，可以透過意象和象徵來呈現。",
  SESSION_EDINBURGH_SANDPLAY_P2: "當單靠語言表達不足以承載內心的經歷時，沙盤治療尤其有幫助——讓一些之前看不見的東西，在治療關係的安全中變得可見。",
  SESSION_EDINBURGH_WHERE_TITLE: "地點",
  SESSION_EDINBURGH_WHERE_P1: "面談地點：",

  // Session Info — Online UK
  META_SESSION_UK_TITLE: "英國網上心理輔導 — 陳渭東，心理治療師",
  META_SESSION_UK_DESC: "全英國網上心理治療及輔導服務——倫敦、曼徹斯特、伯明翰、愛丁堡及其他城市。BACP註冊華人心理治療師。首次諮詢免費。",
  H1_SESSION_UK: "英國網上心理輔導 — 倫敦、曼徹斯特、伯明翰、愛丁堡及其他城市",
  SESSION_UK_INTRO: "無論你身處倫敦、曼徹斯特、伯明翰、列茲、格拉斯哥、布里斯托、利物浦、錫菲，還是英國任何其他地方，我都透過Microsoft Teams提供網上心理輔導。網上治療能提供與面談同等深度和質素的治療工作，同時讓你在最舒適的環境中進行。",
  SESSION_UK_FEES_TITLE: "英國網上心理治療收費",
  SESSION_UK_FEES_INTRO: "",
  SESSION_UK_FEE_FIRST: "首次諮詢（50分鐘）：免費",
  SESSION_UK_FEE_FOLLOWING: "其後每節（50分鐘）：£75",
  SESSION_UK_FEE_CONCESSION: "如有經濟需要，歡迎查詢優惠收費。",
  SESSION_UK_FIRST_TITLE: "首次及其後諮詢",
  SESSION_UK_FIRST_P1: "首次會面是免費的，我們會互相認識，談談政策及如何一起工作，最重要的是，看看你是否覺得與我合作是適合的。當我們同意一起工作並約定合適的時間後，我會提供每週定期的治療時段。",
  SESSION_UK_HOW_TITLE: "如何進行",
  SESSION_UK_HOW_P1: "治療透過Microsoft Teams進行。你只需要穩定的網絡連接和一個安靜、私密的空間。",
  SESSION_UK_HOW_P2: "我現居於蘇格蘭愛丁堡，在英國時間內工作。無論你在英格蘭、蘇格蘭、威爾斯還是北愛爾蘭，我們共享同一時區——安排時間十分方便。",

  // Session Info — Hong Kong
  META_SESSION_HK_TITLE: "香港網上心理輔導及心理治療 — 陳渭東 Perry WT Chan",
  META_SESSION_HK_DESC: "為香港來訪提供廣東話、普通話及英語網上心理治療及輔導。處理抑鬱、焦慮、創傷及關係困難。每節HK$1,100。BACP註冊心理治療師。首次諮詢免費。",
  H1_SESSION_HK: "香港網上心理輔導 — 廣東話、普通話及英語",
  SESSION_HK_INTRO: "我在香港出生和成長，深明這座城市獨有的壓力和文化脈絡——從工作壓力、家庭期望，到跨文化身份認同的困惑。我為香港的來訪提供廣東話、普通話或英語的網上心理輔導——以你最自然的語言進行。",
  SESSION_HK_FEES_TITLE: "香港網上心理治療收費",
  SESSION_HK_FEES_INTRO: "",
  SESSION_HK_FEE_FIRST: "首次諮詢（50分鐘）：免費",
  SESSION_HK_FEE_FOLLOWING: "其後每節（50分鐘）：HK$1,100",
  SESSION_HK_FEE_CONCESSION: "如有經濟需要，歡迎查詢優惠收費。",
  SESSION_HK_FIRST_TITLE: "首次及其後諮詢",
  SESSION_HK_FIRST_P1: "首次會面是免費的，我們會互相認識，談談政策及如何一起工作，最重要的是，看看你是否覺得與我合作是適合的。當我們同意一起工作並約定合適的時間後，我會提供每週定期的治療時段。",
  SESSION_HK_HOW_TITLE: "如何進行",
  SESSION_HK_HOW_P1: "治療透過Microsoft Teams進行。你只需要穩定的網絡連接和一個安靜、私密的空間。",
  SESSION_HK_HOW_P2: "我現居於蘇格蘭愛丁堡（GMT/BST）。香港比英國快7至8小時，我們會找到適合雙方時區的時間——通常是你的晚間或我的早上。",

  // Session Info — International
  META_SESSION_INTL_TITLE: "海外網上心理輔導 — 陳渭東 Perry WT Chan",
  META_SESSION_INTL_DESC: "為海外來訪提供廣東話、普通話及英語網上心理治療。BACP註冊心理治療師，駐愛丁堡，跨時區服務。首次諮詢免費。",
  H1_SESSION_INTL: "海外網上心理輔導 — 廣東話、普通話及英語",
  SESSION_INTL_INTRO: "如果你身處英國及香港以外的地方，我同樣歡迎海外的來訪。我透過Microsoft Teams提供廣東話、普通話或英語的網上心理輔導——無論你在世界任何角落。",
  SESSION_INTL_FEES_TITLE: "網上心理治療收費",
  SESSION_INTL_FEES_INTRO: "",
  SESSION_INTL_FEE_FIRST: "首次諮詢（50分鐘）：免費",
  SESSION_INTL_FEE_FOLLOWING: "其後每節（50分鐘）：£75",
  SESSION_INTL_FEE_CONCESSION: "如有經濟需要，歡迎查詢優惠收費。",
  SESSION_INTL_FIRST_TITLE: "首次及其後諮詢",
  SESSION_INTL_FIRST_P1: "首次會面是免費的，我們會互相認識，談談政策及如何一起工作，最重要的是，看看你是否覺得與我合作是適合的。當我們同意一起工作並約定合適的時間後，我會提供每週定期的治療時段。",
  SESSION_INTL_HOW_TITLE: "如何進行",
  SESSION_INTL_HOW_P1: "治療透過Microsoft Teams進行。你只需要穩定的網絡連接和一個安靜、私密的空間。",
  SESSION_INTL_HOW_P2: "我現居於蘇格蘭愛丁堡（GMT/BST）。我們會找到適合雙方時區的時間。",

  METITLE1: "Lost",
  ME1: "Born and grew up in Hong Kong, I later moved to the UK for higher education in my teenage years. Done my undergrad, done my master’s, feeling lost, hit the road, spent several years working and travelling around the world, looked for my soul, started personal therapy…….my journey started from here…",
  ME2: "“Perhaps one day you don’t need to go anywhere because you have the whole world in you?” A Jungian analyst spoke to me.",
  ME3: "“What do you mean?”",
  ME4: "Like a monk meditating on a Mandala which encapsulates the whole universe.”",
  ME5: "“... I think I’m escaping from something... ”",
  PIC10: "Koi fish, Tokyo 2018 spring",
  PIC11: "When you brush past your dark side it goes so quickly yet enlightens you",
  METITLE2: "Encountering",
  ME6: "This exchange occurred years ago.",
  ME7: "It was the time I started looking into myself, my inner process.",
  ME8: "Encountering my shadows, the dark sides of myself, my vulnerabilities…painful yet insightful.",
  ME9: "Digging deep, peeling off my wound, layer by layer......excoriating and excruciating......",
  METITLE3: "Koans",
  ME10: "“Yea I'm lost. What can I do?”",
  ME11: "“I don’t know” the analyst answered immediately.",
  ME12: "“…can you tell me what to do?”",
  ME13: "“Stop asking this question. When the right time has come, you will know what to do. Now stay reflective and curious.”",
  ME14: "Like a koan, solving it in our head is pointless. Indwelling ourselves in it is the way to understand it. This was the time when I learnt to indwell in my painful experience and started this life-long commitment to looking into my psyche and developing my self-awareness, as well as staying reflective on the tensions with any other beings.",
  PIC12: "Self-discovery, making the unconscious conscious",
  PIC13: "Meditation has become my daily practice. (Meditation in Japan, 2018)",
  METITLE4: "My Ways of Being",
  ME15: "Personal therapy and meditation are practices which keep me alive, reflective, creative and grounded and thus shapes my ways of being. This has thus allowed me to work with my clients ethically and professionally.",
  COPY4: "© 2021, Perry W.T. Chan. All Rights Reserved.",
  E4: "Get in Touch: perrywtchan@protonmail.com",
  SDTITLE1: "What is Social Dreaming?",
  SD1: "COMING SOON",

//ContactForm//
getInTouch: "聯絡我",
contactEmail: "perrywtchan@protonmail.com",
formName: "你的名字",
formEmail: "你的電郵",
formMessage: "你的留言",
formSend: "傳送 →",
formSuccess: "謝謝你的留言，我會盡快回覆。",
formError: "發生錯誤，請直接電郵聯絡我。",


//SocialDreamingAbout//
tabAboutSdm: "關於SDM",
tabLondonJuly: "July, London",
tabLondonDec: "Dec, London",

//SocialDreamingAbout//
ullmanQuote: "Our dreaming self is more concerned with the nature of our connections with all others . . . is connected with the basic truth that we're all members of a single species . . . ",
ullmanName: "Ullman, 1981",
whatIsSDM: "甚麼是Social Dreaming Matrix (SDM)?",
whatIsSDM_P1:"Lawrence (1999) 是使用夢材料來探索社會過程的先驅。 Dream Matrix的參與者被邀請分享他們做過的夢，並通過自由聯想將夢與夢聯繫起來，例如圖像、感覺、直覺反應、記憶、思想、另一個夢、夢的片段、書籍、電影、詩歌等。 通過夢和聯想，我們嘗試尋找和建立聯繫，並探索新的想法。 在Matrix中，我們著重的是夢，而不是做夢者本身。沒有任何一個夢比另外一個夢重要。",
whatIsSDM_P2: "Matrix之後通常是夢境反思對話 (Dream Reflection Dialogue; DRD)，我們在其中探索和識別Matrix中出現的情緒、思想和主題，從而可以探索社會系統的潛在問題。",
dreamingMushrooms2: "Dreaming Mushrooms (Perry Chan 2022)",
dreamingFishes: "Dreaming fishes (Perry Chan 2022)",
SocialDreamingAbout_ref: "參考文獻",

//SocialDreaming/LondonJuly//
londonJuly_EventName: "香港Social Dreaming Matrix - 一個讓你發夢、想像、發現未知的空間",
londonJuly_sdDate: "July 30 & Aug 6 (Sat), 2022, 11am-3pm, London",
ullmanFullName: "Montague Ullman",
londonJuly_eventIntro: "香港正經歷前所未有的動盪。 這種持續的動盪如何影響、威脅和塑造香港人的認同感、心靈、社會和文化情結等等？ 你有興趣在更深層次—無意識和集體層面上—一起探索嗎？你想體驗一種不同的思維空間嗎？",
londonJuly_freeEvent: "此活動費用全免，主辦人亦無收取任何款項。",
londonJuly_contact: "如有興趣參與或有任何疑問，請聯繫：",
londonJuly_email: "perrywtchan@protonmail.com",
dreamingMushrooms: "Dreaming Mushrooms (Perry Chan 2022)",
refer: "請看",
learnMore: "了解更多。 ",
whatIsSDM_intro: "參與者不需要任何Social Dreaming的經驗和知識。 在介紹環節中，我們將會簡單介紹SD，例如分享夢境的意義、集體無意識、我們在深層次上相互聯繫的方式等。我們將在兩個週末並在一個舒適的環境中舉辦這4個SD ，附近設有可以午休的咖啡店。",
CanIParticipate: "我可以參與嗎？",
londonJuly_participate_invite: "我們正在邀請10個參與者。 如果你符合以下條件就可以參與:",
londonJuly_Participate_c1: "•	有興趣探討香港的動盪",
londonJuly_Participate_c2: "•	視自己為香港人",
londonJuly_Participate_c3: "•	已滿 18 歲",
londonJuly_Participate_c4: "•	能用英語交流",
londonJuly_Participate_c5: "•	願意與所有參加者分享和參與Matrix中出現的夢境或聯想",
sdmNotTherapy: "SDM並不是心理治療。 它是我們分享夢境和聯想，一個安全且非對抗的空間。 參與者需要對他們的參與程度和心理健康負責。",
londonJuly_venue: "地點",
londonJuly_venueDistance: "(由Swiss Cottage地鐡站步行6分鐘)",
londonJuly_agenda: "流程",
londonJuly_agendaNote1: "注意：DRD是指夢境反思對話。 要了解更多，請參閱",
londonJuly_agendaNote2: "; 參與者請在上午 10:45 到達，以便 SDM 可以在上午 11 點準時開始。",
londonJuly_confidentiality: "保密",
londonJuly_confidentiality_p1: "此活動不會收集和存儲任何個人資料。 在介紹環節和SDM中不會被錄音。 主持人會在SD期間做筆記或畫畫，這個過程會被記錄在筆記設備中（僅屏幕）。 ",
londonJuly_confidentiality_p2: "但是任何個人資料和任何可能與參與者的身份有相關聯的元素會被省略。 每個參與者(包括主持人)都有責任保護所有人的私隱並尊重機密性。 談論Matrix中出現的都需要匿名。",
londonJuly_AboutHost: "關於主持人",
londonJuly_AboutHost_perry: "Perry WT Chan 為心理治療師，曾在非政府組織工作，主要在英國和香港私人執業。 他對早期的關係（童年）創傷和社會集體創傷特別感興趣。 他在愛丁堡大學擔任心理治療課程的導師和研究員（目前正在撰寫博士論文）。",
londonJuly_AboutHost_claire: "Claire Manson 為藝術家和藝術心理治療師，在 NHS 和獨立部門工作了 40 多年。 她與其他人共同創立了'Studio Upstairs'，是一個藝術工作室和治療空間。她亦在人權組織提供心理治療，志願服務社群並會繼續這樣做。",



}